import script from "./WebsiteTicino.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteTicino.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__